import { oz } from '@weft/utils';
import { SanitizedStringSchema } from './sanitizedStringSchema';

export const ErpMetadataSchema = oz.object({
  erpId: SanitizedStringSchema,
  erpName: SanitizedStringSchema,
  displayId: SanitizedStringSchema.nullable().optional(),
}).openapi('ErpMetadata');

export type ErpMetadata = oz.infer<typeof ErpMetadataSchema>;
